import { AllPagesComponent } from './components/all-pages/all-pages.component';
import { DsShellComponent } from './common/ds-shell/ds-shell.component';
import { DsSectionHubComponent } from './common/ds-shell/section-hub/ds-section-hub.component';
import { DsSharedModule } from './common/ds-shared.module';
import { ConnectionRequestsComponent } from './components/artist-components/connection-requests/connection-requests.component';
import { DispatchComponent } from './components/artist-components/dispatch/dispatch.component';
import { ShowPortfoliosProductsDialogComponent } from './common/show-portfolios-products-dialog/show-portfolios-products-dialog.component';
import { SingleProductSyncComponent } from './common/view-artwork/single-product-sync/single-product-sync-component';
import { NgModule, Injector, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JWT_OPTIONS, JwtHelperService, JwtModule } from '@auth0/angular-jwt';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ToastModule } from 'primeng/toast';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { NotificationsService } from './Services/shared/notifications.service';
import { AuthService } from './Services/auth.service';
import { DropdownModule } from 'primeng/dropdown';
import { PanelModule } from 'primeng/panel';
import { TabViewModule } from 'primeng/tabview';
import { AuthGuard } from './components/Guards/authGuard';
import { MenuModule } from 'primeng/menu';
import { ToolbarModule } from 'primeng/toolbar';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ProgressBarModule } from 'primeng/progressbar';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TimelineModule } from 'primeng/timeline';
import { ChartModule } from 'primeng/chart';
import { SidebarComponent } from './common/sidebar/sidebar.component';
import { ConnectionsService } from './Services/connections.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { EditprofileComponent } from './common/editprofile/editprofile.component';
import { AddressAutocompleteComponent } from './common/address-autocomplete/address-autocomplete.component';
import { HelpLauncherComponent } from './help/components/help-launcher/help-launcher.component';
import { ConnectionRequestComponent } from './components/connection-request/connection-request.component';
import { AuthComponent } from './components/auth/auth.component';
import { ArtistDashboardComponent } from './components/artist-components/artist-dashboard/artist-dashboard.component';
import { GalleryDashboardComponent } from './components/gallery-components/gallery-dashboard/gallery-dashboard.component';
import { ViewArtistComponent } from './components/gallery-components/view-artist/view-artist.component';
import { GalleriaModule } from 'primeng/galleria';
import { RadioButtonModule } from 'primeng/radiobutton';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { SignupComponent } from './components/signup/signup.component';
import { SubscriptionsModule } from './modules/subscriptions/subscriptions.module';
import { ViewArtworkComponent } from './common/view-artwork/view-artwork.component';
import { StripeConnectComponent } from './common/stripe-connect/stripe-connect.component';
import { ViewUserInvoiceComponent } from './common/view-user-invoice/view-user-invoice.component';
import { RegistrationComponent } from './components/registration/registration.component';
import { RegistrationsService } from './Services/registration.service';
import { ApplicationLogService } from './Services/applicationlogs.service';
import { ConsignmentProductSelectionComponent } from './components/gallery-components/consignment-product-selection/consignment-product-selection.component';
import { DashboardService } from './Services/dashboard.service';
import { ViewConsignmentsComponent } from './components/artist-components/view-consignments/view-consignments.component';
import { CommonModule } from '@angular/common';
import { AdminModule } from './modules/admin/admin.module';
import { AccountDeleteComponent } from './common/account-deletion/account-delete.component';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { EmailTrackLogComponent } from './components/admin-level/all-galleries/email-track-log/email-track-log.component';
import { ForgotPasswordComponent } from './common/forgot-password/forgot-password.component';
import { GallerysModule } from './modules/galleries/galleries.module';
import { TooltipModule } from 'primeng/tooltip';
import { SocialAccountComponent } from './common/social-account/social-account.component';
import { AppChatBox } from './common/chat-box/chat-box.component';
import { AppMessagesComponent } from './common/messages/messages.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { BaseModule } from './models/base/base.module';
import { InputSwitchModule } from 'primeng/inputswitch';
import { AdminInsightsChartComponent } from './components/admin-level/admin-insights-chart/admin-insights-chart.component';
import { AdminDashboard } from './components/admin-level/admin-dashboard/admin-dashboard.component';
import { GuidedTourModule, GuidedTourService } from 'ngx-guided-tour';
import { StepsModule } from 'primeng/steps';
import { GalleryInsightChartComponent } from './components/gallery-components/gallery-insights-charts/gallery-insights-charts.component';
import { OnBoardingService } from './Services/shared/onboarding.service';
import { ArtistOnboardingCheckListComponent } from './components/artist-components/artist-onboarding-check-list/artist-onboarding-checklist.component';
import { OnboardingArtistPersonalDetailsComponent } from './components/artist-components/onboarding-artist-personal-details/onboarding-artist-personal-details.component';
import { OnboardingArtistProductComponent } from './components/artist-components/onboarding-artist-product/onboarding-artist-product.component';
import { OnboardingArtistResumeComponent } from './components/artist-components/onboarding-artist-resume/onboarding-artist-resume.component';
import { OnboardingGalleryPersonalDetailsComponent } from './components/gallery-components/onboarding-gallery-personal-details/onboarding-gallery-personal-details.component';
import { GalleryOnboardingChecklistComponent } from './components/gallery-components/gallery-onboarding-checklist/gallery-onboarding-checklist.component';
import { InitializationService } from './Services/initializer/initialization.service';
import { UsersService } from './Services/users.service';
import { ArtworkDetailsComponent } from './components/artist-components/artwork-details/artwork-details.component';
import { PriceCalculatorComponent } from './components/artist-components/price-calculator-dialog/price-calculator-dialog.component';
import { ViewConsignmentComponent } from './components/artist-components/view-consignment/view-consignment.component';
import { ConsignmentDataComponent } from './components/consignment-data/consignment-data.component';
import { ArtistSaleHistoryComponent } from './components/artist-components/artist-sale-history/artist-sale-history.component';
import { GlazeTransformerPipe } from './pipes/glazetransformer.pipe';
import { UpgradeDialogComponent } from './components/artist-components/upgrade-dialog/upgrade-dialog.component';
import { ArtistsComponent } from './components/admin-level/artists/artists.component';
import { FreeTrialFeatureDialogComponent } from './components/artist-components/free-trial-feature-dialog/free-trial-feature-dialog.component';
import { GalleryProductComponent } from './components/gallery-components/gallery-product/gallery-product.component';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { AccordionModule } from 'primeng/accordion';
import { ProductSocialMediaSharesComponent } from './common/product-social-media-shares/product-social-media-shares.component';
import { ShareableProductComponent } from './components/shareable-product/shareable-product.component';
import { SharedListProductsComponent } from './components/shared-list-products/shared-list-products.component';
import { ConnectSquareupPosAccountComponent } from './components/connect-squareup-pos-account/connect-squareup-pos-account.component';
import { ShopifyAccount } from './components/gallery-components/shopify-account/shopify-account.component';
import { ConnectWithShopifyAccount } from './components/gallery-components/connect-with-shopify-account/connect-with-shopify-account.component';
import { GalleryShareableProductComponent } from './components/gallery-components/gallery-shareable-products/gallery-shareable-products.component';
import { ConnectWoocommerceAccountComponent } from './components/gallery-components/connect-woocommerce-account/connect-woocommerce-account.component';
import { SyncProductsComponent } from './components/gallery-components/sync-products/sync-products.component';
import { CalendarModule } from 'primeng/calendar';
import { ProductDisplayComponent } from './components/artist-components/artist-productdisplay/product-display.component';
import { SidebarModule } from 'primeng/sidebar';
import { ArtistSelectedProductDialogComponent } from './components/shareable-product/artist-selected-product-dialog/artist-selected-product-dialog.component';
import { WixComponent } from './components/connect-with-wix/wix.component';
import { DragDropModule } from 'primeng/dragdrop';
import { CurrencyExchangeDialogComponent } from './common/view-artwork/currency-exchange-dialog/currency-exchange-dialog.component';
// import { ShopifyAndWooCommerceDailog } from './components/gallery-components/shopify-and-woocommerce-dailog/shopify-and-woocomerce-dailog.component';
// import { PlatformCurrencySettingsDialogComponent } from './components/gallery-components/consignment-product-selection/platforms-currency-settings-dialogs/platform-currency-settings-dialog.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner'; // PrimeNG Progress Spinner
import { ArtistArtworksComponent } from './components/artist-components/artist-artworks/artist-artworks.component';
import { ConnectedGalleriesComponent } from './components/artist-components/connected-galleries/connected-galleries.component';
import { NotesDialogComponent } from './common/notes-dialog/notes-dialog.component';
import { ConnectedArtistsComponent } from './components/gallery-components/connected-artists/connected-artists.component';
import { ConnectedartistsNotesComponent } from './components/artist-components/connectedartists-notes/connectedartists-notes.component';
import { ArtworkcategorykComponent } from './components/artist-components/art-work-categories/art-workcategory.component';
import { ProductClaysComponent } from './components/artist-components/product-clays/product-clays.component';
import { ProductSeriesComponent } from './components/artist-components/product-series/product-series.component';
import { ProductGlazesComponent } from './components/artist-components/product-glazes/product-glazes.component';
import { SetupDailogComponent } from './components/setup-dailog/setup-dailog.component';
import { PlanGuard } from './components/Guards/planGuard';
import { ProductPlatformLogoDialogComponent } from './components/gallery-components/sync-products/product-platform-logo-dialog/product-platform-logo-dialog.component';
import { InstagramAccountComponent } from './common/instagram-account/instagram-account.component';
import { CreateSocialPost } from './common/create-social-post/create-social-post.component';
import { DeleteMetaDataComponent } from './components/delete-meta-data/delete-meta-data.component';
import { DeleteInstagramMetaDataComponent } from './components/delete-instagram-meta-data/delete-instagram-meta-data.component';
import { environment } from 'src/environments/environment';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { NotificationsComponent } from './common/notifications/notifications.component';
import { NotificationListComponent } from './components/notification-lists/notification-lists.component';
import { AcceptInvitationComponent } from './components/accept-invitation/accept-invitation.component';
import { ProductSyncComponent } from './components/gallery-components/products-sync/product-sync.component';
import { SyncProductsArtistComponent } from './components/artist-components/sync-products-artist/sync-products-artist.component';
import { ArtistProductInfoEmptyPageComponent } from './components/artist-components/artist-product-info-empty-page/artist-product-info-empty-page.component';
import { FilterByPlatformPipe } from './pipes/filter-by-platform.pipe';
import { SquareSpace } from 'src/app/common/SquareSpace/square-space.component';
import { ViewConsignmemtProductComponent } from './components/artist-components/view-consignmemt-product/view-consignmemt-product.component';
import { LabelsGenerationComponent } from './components/gallery-components/labels-generation/labels-generation.component';
import { UpgradeAccountComponent } from './components/competition/upgrade-account/upgrade-account.component';
import { ImageEditorComponent } from './components/artist-components/image-editor/image-editor.component';
import { ImageStudioComponent } from './components/artist-components/image-studio/image-studio.component';
import { DsHeaderComponent } from './common/ds-header/ds-header.component';
import { DsGalleryHeaderComponent } from './common/ds-gallery-header/ds-gallery-header.component';
import { DsArtistDashboardComponent } from './components/artist-components/ds-artist-dashboard/ds-artist-dashboard.component';
import { DsArtistInsightsChartComponent } from './components/artist-components/ds-artist-insights-chart/ds-artist-insights-chart.component';
import { DsGalleryDashboardComponent } from './components/gallery-components/ds-gallery-dashboard/ds-gallery-dashboard.component';
import { DsAdminHeaderComponent } from './common/ds-admin-header/ds-admin-header.component';
import { DsAdminDashboardComponent } from './components/admin-level/ds-admin-dashboard/ds-admin-dashboard.component';
import { provideTransloco, TranslocoModule } from '@jsverse/transloco';
import { TranslocoHttpLoader } from './transloco-loader';
import { LanguageSwitcherComponent } from './common/language-switcher/language-switcher.component';

export function getTokenFactory(injector: Injector) {
  return {
    tokenGetter: () => {
      var authService = injector.get(AuthService);
      var token = authService.getAccessToken();
      return token;
    },
    skipWhenExpired: true,
    allowedDomains: ['localhost:44303']
  }
}

export function appInitializerFactory(appInitService: InitializationService) {
  return () => appInitService.initializeApp();
}

@NgModule({ declarations: [
        AppComponent,
        AllPagesComponent,
        DsShellComponent,
        DsSectionHubComponent,
        ConnectionRequestsComponent,
        DispatchComponent,
        NotificationsComponent,
        NotificationListComponent,
        SidebarComponent,
        AuthComponent,
        DashboardComponent,
        ViewConsignmentsComponent,
        EditprofileComponent,
        SignupComponent, AcceptInvitationComponent,
        RegistrationComponent,
        ConsignmentProductSelectionComponent,
        AccountDeleteComponent,
        ConnectionRequestComponent,
        StripeConnectComponent,
        ArtistDashboardComponent,
        GalleryDashboardComponent,
        ViewArtistComponent,
        ViewArtworkComponent,
        ViewUserInvoiceComponent,
        EmailTrackLogComponent,
        ForgotPasswordComponent,
        SocialAccountComponent,
        AppChatBox,
        AppMessagesComponent,
        AdminInsightsChartComponent,
        AdminDashboard,
        ProductSyncComponent,
        GalleryInsightChartComponent,
        ArtistOnboardingCheckListComponent,
        OnboardingArtistPersonalDetailsComponent,
        OnboardingArtistProductComponent,
        OnboardingArtistResumeComponent,
        OnboardingGalleryPersonalDetailsComponent,
        GalleryOnboardingChecklistComponent,
        ArtworkDetailsComponent,
        PriceCalculatorComponent,
        ViewConsignmentComponent,
        ConsignmentDataComponent,
        ArtistSaleHistoryComponent,
        GlazeTransformerPipe,
        UpgradeDialogComponent,
        ArtistsComponent,
        FreeTrialFeatureDialogComponent,
        GalleryProductComponent,
        ProductSocialMediaSharesComponent,
        ShareableProductComponent,
        SharedListProductsComponent,
        ConnectSquareupPosAccountComponent,
        ShopifyAccount,
        ConnectWithShopifyAccount,
        GalleryShareableProductComponent,
        ConnectWoocommerceAccountComponent,
        SyncProductsComponent,
        ProductDisplayComponent,
        ArtistSelectedProductDialogComponent,
        WixComponent,
        CurrencyExchangeDialogComponent,
        SingleProductSyncComponent,
        ArtistArtworksComponent,
        ConnectedGalleriesComponent,
        NotesDialogComponent,
        ConnectedArtistsComponent,
        ConnectedartistsNotesComponent,
        SetupDailogComponent, ProductPlatformLogoDialogComponent,
        ProductSeriesComponent, ProductClaysComponent, ArtworkcategorykComponent, ProductGlazesComponent,
        InstagramAccountComponent,
        CreateSocialPost,
        DeleteMetaDataComponent,
        DeleteInstagramMetaDataComponent,
        ShowPortfoliosProductsDialogComponent,
        SyncProductsArtistComponent,
        ArtistProductInfoEmptyPageComponent,
        FilterByPlatformPipe,
        SquareSpace,
        ViewConsignmemtProductComponent,
        LabelsGenerationComponent,
        UpgradeAccountComponent,
        DsHeaderComponent,
        DsGalleryHeaderComponent,
        DsArtistDashboardComponent,
        DsArtistInsightsChartComponent,
        DsGalleryDashboardComponent,
        DsAdminHeaderComponent,
        DsAdminDashboardComponent
    ],
    bootstrap: [AppComponent], imports: [DsSharedModule, AddressAutocompleteComponent, HelpLauncherComponent, BrowserModule, FormsModule, BrowserAnimationsModule, ProgressBarModule, SelectButtonModule, TimelineModule, CommonModule, AdminModule, NgxImageZoomModule, BaseModule, StepsModule, BreadcrumbModule, MultiSelectModule,
        AppRoutingModule, AngularEditorModule, OverlayPanelModule, ChartModule, TableModule, ToastModule, ButtonModule, ConfirmDialogModule, GallerysModule, TooltipModule, ImageCropperModule, InputSwitchModule, AccordionModule,
        NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }), RadioButtonModule, CalendarModule, SidebarModule, ProgressSpinnerModule,
        DropdownModule, PanelModule, TabViewModule, ToolbarModule, MenuModule, CheckboxModule, DialogModule, FileUploadModule, GalleriaModule,
        InputTextareaModule, GuidedTourModule, DragDropModule, SubscriptionsModule.forRoot(),
        JwtModule.forRoot({
            jwtOptionsProvider: {
                provide: JWT_OPTIONS,
                deps: [Injector],
                useFactory: getTokenFactory
            }
        }),
        AngularFireModule.initializeApp(environment.firebase), // Ensure Firebase initializes properly
        AngularFireMessagingModule,
        ImageEditorComponent, ImageStudioComponent, TranslocoModule, LanguageSwitcherComponent], providers: [NgxSpinnerService, MessageService, ConfirmationService, ApplicationLogService, NotificationsService,
        AuthGuard, PlanGuard, ConnectionsService, DashboardService, AuthService, JwtHelperService,
        RegistrationsService, GuidedTourService, OnBoardingService, InitializationService, UsersService,
        {
            provide: APP_INITIALIZER,
            deps: [InitializationService],
            multi: true,
            useFactory: appInitializerFactory
        }, provideHttpClient(withInterceptorsFromDi()),
        provideTransloco({
            config: {
                availableLangs: ['en', 'fr', 'de', 'es'],
                defaultLang: 'en',
                fallbackLang: 'en',
                reRenderOnLangChange: true,
                prodMode: environment.production,
                missingHandler: { logMissingKey: !environment.production, useFallbackTranslation: true }
            },
            loader: TranslocoHttpLoader
        })] })
export class AppModule { }